import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "Docs";

export const Listar = (filtros) =>
  RequestWebApi.get(`/${controller}/Listar`, {
    params: {
      criterioBusca: filtros?.criterioBusca
    },
  })
    .then((response) => {
      const { resultData, success } = response.data;
      const documentos = resultData || [];
      return { success, documentos };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      return { documentos: [] };
    });

export const ListarDocsPorCriterio = (filtros) =>
  RequestWebApi.get(`/${controller}/ListarDocsPorCriterio`, {
    params: {
      tipoDocsId: filtros?.tipoDocsId,
      subTipoDocsId: filtros?.subTipoDocsId,
      criterioBusca: filtros?.criterioBusca
    },
  })
    .then((response) => {
      const { resultData, success } = response.data;
      const documentos = resultData || [];
      return { success, documentos };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      return { documentos: [] };
    });

export const Detalhes = (docsId) =>
  RequestWebApi.get(`/${controller}/Detalhes`, {
    params: { docsId },
  })
    .then((response) => {
      const { resultData, success } = response.data;
      const documento = resultData || {};
      return { success, documento };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors, documento: {} };
    });

export const Incluir = (doc) => {

  const form = new FormData();
  form.append("SubTipoDocsId", doc.subTipoDocsId);
  form.append("DocsNome", doc.docsNome || "");
  form.append("DocsDescricao", doc.docsDescricao || "");
  form.append("DocsTags", doc.docsTags || "");
  form.append("DocsConfidencialidade", doc.docsConfidencialidade || "");
  form.append("DocsStatus", doc.docsStatus || "");
  form.append("DocsDataValidade", doc.docsDataValidade || "");

  // GrupoUsuarioList
  (doc.grupoUsuarioList || []).forEach((x, i) => {
    form.append(`GrupoUsuarioList[${i}].GrupoUsuarioId`, String(x.grupoUsuarioId ?? 0));
  });

  // UsuarioList
  (doc.usuarioList || []).forEach((x, i) => {
    form.append(`UsuarioList[${i}].UsuarioId`, String(x.usuarioId ?? 0));
  });

  // DocumentoList
  (doc.documentoList || []).forEach((x, i) => {
    form.append(`DocumentoList[${i}].DocsId`, String(x.docsId ?? 0));
  });


  form.append("Arquivo", doc.arquivoSelecionado);

  return RequestWebApi.post(`/${controller}/Incluir`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((response) => {
      const { resultData, success } = response.data;
      const novoDocumento = resultData;
      return { success, novoDocumento };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors };
    });
};

export const Atualizar = (doc) => {
  const form = new FormData();
  form.append("DocsId", doc.docsId);
  form.append("SubTipoDocsId", doc.subTipoDocsId);
  form.append("DocsNome", doc.docsNome || "");
  form.append("DocsDescricao", doc.docsDescricao || "");
  form.append("DocsTags", doc.docsTags || "");
  form.append("DocsConfidencialidade", doc.docsConfidencialidade || "");
  form.append("DocsStatus", doc.docsStatus || "");
  form.append("DocsDataValidade", doc.docsDataValidade || "");

  // GrupoUsuarioList
  (doc.grupoUsuarioList || []).forEach((x, i) => {
    form.append(`GrupoUsuarioList[${i}].GrupoUsuarioId`, String(x.grupoUsuarioId ?? 0));
  });

  // UsuarioList
  (doc.usuarioList || []).forEach((x, i) => {
    form.append(`UsuarioList[${i}].UsuarioId`, String(x.usuarioId ?? 0));
  });

  // DocumentoList
  (doc.documentoList || []).forEach((x, i) => {
    form.append(`DocumentoList[${i}].DocsId`, String(x.docsId ?? 0));
  });

  form.append("Arquivo", doc.arquivoSelecionado);

  return RequestWebApi.put(`/${controller}/Atualizar`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((response) => {
      const { success } = response.data;
      return { success };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors };
    });


};


export const Remover = (docsId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { docsId },
  })
    .then((response) => {
      const { success } = response.data;
      return { success };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors };
    });
